/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ChildPortfolioRecordTypeEnum } from './childPortfolioRecordTypeEnum';

/**
 * Base serializer with shared logic for Record operations.
 */
export interface RecordUpdate { 
    /**
     * Vyberte typ záznamu, který chcete vytvořit.  * `activity` - Aktivita * `touch` - Dotek
     */
    recordType?: ChildPortfolioRecordTypeEnum;
    date: string;
    relatedChildren: Array<string>;
    group?: string;
    /**
     * Zadejte podrobný popis záznamu.
     */
    description?: string;
    /**
     * Vyberte aktivitu, ke které tento záznam patří.
     */
    activity?: string;
    skills?: Array<string>;
    competencies?: Array<string>;
    literacies?: Array<string>;
    /**
     * Zaškrtněte, pokud má být aktivita zaznamenána v třídní knize.
     */
    gradeBookRecord?: boolean;
}